export enum RequestConfig {
  Vault,
  Unauthed,
  Form,
  Default,
  Agent,
}
